import request from '@/config/axios'
import { merchantApi } from '@/config/axios'
import { supplierApi } from '@/api/mall/product/supplierPortal'

/** ========== A ========== */
export const getAdminSettleEligibleGroups = (params: {
  periodStart: string
  periodEnd: string
}) => request.get({ url: '/trade/supplier-settle/eligible-groups', params })
export const generateAdminSettle = (data: any) =>
  request.post({ url: '/trade/supplier-settle/generate', data })
export const getAdminSettlePage = (params: any) =>
  request.get({ url: '/trade/supplier-settle/page', params })
export const getAdminSettle = (id: number) =>
  request.get({ url: '/trade/supplier-settle/get', params: { id } })
export const confirmAdminSettle = (id: number) =>
  request.put({ url: '/trade/supplier-settle/confirm', params: { id } })
export const invalidateAdminSettle = (id: number, remark?: string) =>
  request.put({ url: '/trade/supplier-settle/invalidate', params: { id, remark } })
export const payRecordAdminSettle = (data: any) =>
  request.put({ url: '/trade/supplier-settle/pay-record', data })

/** ========== B ========== */
export const getMerchantSettlePage = (params: any) =>
  merchantApi.get({ url: '/merchant-api/trade/supplier-settle/page', params })
export const getMerchantSettle = (id: number) =>
  merchantApi.get({ url: '/merchant-api/trade/supplier-settle/get', params: { id } })
export const confirmMerchantSettle = (id: number) =>
  merchantApi.put({ url: '/merchant-api/trade/supplier-settle/confirm', params: { id } })
export const invalidateMerchantSettle = (id: number, remark?: string) =>
  merchantApi.put({ url: '/merchant-api/trade/supplier-settle/invalidate', params: { id, remark } })

/** ========== S ========== */
export const getSupplierSettlePage = (params: any) =>
  supplierApi.get({ url: '/supplier-api/trade/supplier-settle/page', params })
export const getSupplierSettle = (id: number) =>
  supplierApi.get({ url: '/supplier-api/trade/supplier-settle/get', params: { id } })
